(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

export var showWorkSpaceProjectIds = [process.env.REACT_APP_JCB_ENV === "dev" ? "1308" : "1255"];

var customProjects = [{
  name: "新政",
  mainId: process.env.REACT_APP_JCB_ENV === "dev" ? "1308" : "1255",
  innerId: [process.env.REACT_APP_JCB_ENV === "dev" ? "1308" : "1255", process.env.REACT_APP_JCB_ENV === "dev" ? "1311" : "1259", process.env.REACT_APP_JCB_ENV === "dev" ? "1309" : "1256"],
  menus: ["工作台", "项目设置"],
  menusLink: ["config/"]
}];

export var isShowWorkSpace = function isShowWorkSpace(projectId) {
  var obj = customProjects.find(function (v) {
    return (v.innerId.indexOf(projectId) > -1 || v.mainId === projectId) && window.location.href.indexOf("workspace") === -1;
  });
  if (obj) {
    var o = obj.menusLink.find(function (v) {
      return window.location.href.indexOf(v) > -1;
    });
    if (o) {
      return true;
    }
  }
  return showWorkSpaceProjectIds.indexOf(projectId) > -1 && window.location.href.indexOf("workspace") > -1;
};

// 判断是否属于工作台内项目
export var isInnerWorkSpace = function isInnerWorkSpace(projectId) {
  var obj = customProjects.find(function (v) {
    return (v.innerId.indexOf(projectId) > -1 || v.mainId === projectId) && window.location.href.indexOf("workspace") === -1;
  });
  if (obj) {
    var o = obj.menusLink.find(function (v) {
      return window.location.href.indexOf(v) > -1;
    });
    if (o) {
      return null;
    }
    return obj.mainId;
  }
  return null;
};

// 工作台菜单、工作台同项目的内部菜单
export var menusWorkSpace = function menusWorkSpace(projectId, menus) {
  var obj = customProjects.find(function (v) {
    return v.mainId === projectId;
  });
  if (obj) {
    if (window.location.href.indexOf("workspace") === -1) {
      var o = obj.menusLink.find(function (v) {
        return window.location.href.indexOf(v) > -1;
      });
      if (o) {
        return menus.filter(function (v) {
          return obj.menus.indexOf(v.name) > -1;
        });
      }
      return menus.filter(function (v) {
        return obj.menus.indexOf(v.name) === -1;
      });
    }
    return menus.filter(function (v) {
      return obj.menus.indexOf(v.name) > -1;
    });
  }
  return [];
};

// 企业判断：只显示检查吧
export var onlyShowJcbCompanyIds = [{
  id: process.env.REACT_APP_JCB_ENV === "dev" ? "133" : "1450945",
  name: "天津市宁河区文明城区创建实地检查系统",
  backProjects: false
}, {
  id: process.env.REACT_APP_JCB_ENV === "dev" ? "20136" : "1450966",
  name: "大兴区文明创城",
  backProjects: false
}];

export var isOnlyShowJcb = function isOnlyShowJcb(companyId, projectId) {
  return onlyShowJcbCompanyIds.find(function (v) {
    return v.id === companyId;
  }) && !projectId;
};

export var isBackProjects = function isBackProjects(companyId) {
  if (!companyId) {
    return false;
  }
  return onlyShowJcbCompanyIds.find(function (v) {
    return v.id === companyId && v.backProjects === false;
  });
};
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(showWorkSpaceProjectIds, "showWorkSpaceProjectIds", "src/utils/custom-project.js");
  reactHotLoader.register(customProjects, "customProjects", "src/utils/custom-project.js");
  reactHotLoader.register(isShowWorkSpace, "isShowWorkSpace", "src/utils/custom-project.js");
  reactHotLoader.register(isInnerWorkSpace, "isInnerWorkSpace", "src/utils/custom-project.js");
  reactHotLoader.register(menusWorkSpace, "menusWorkSpace", "src/utils/custom-project.js");
  reactHotLoader.register(onlyShowJcbCompanyIds, "onlyShowJcbCompanyIds", "src/utils/custom-project.js");
  reactHotLoader.register(isOnlyShowJcb, "isOnlyShowJcb", "src/utils/custom-project.js");
  reactHotLoader.register(isBackProjects, "isBackProjects", "src/utils/custom-project.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();